<template>
  <div id="notice">
    <el-tabs v-model="activeNotice" type="border-card"  @tab-click="handleClick">
      <el-tab-pane label="通知公告" name="notice">
        <ul class="text item">
          <router-link v-for="(notice,index) of noticeData.data" :key="notice.id" :to="{name:'NoticeItem',query:{id: notice.id,type: 'notice'}}" tag="li">
            <i v-show="notice.is_top == 1" class="el-icon-star-on"></i>  <span v-text="notice.title"></span>
          </router-link>
	  		  <li class="not-more" v-show="noticeLoaded">已经是最后一页了</li>
        </ul>
        <div class="btn-box">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="changeNoticeList"
            :current-page="noticeData.current_page"
            :total="noticeData.total">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="办卡注意事项" name="tips">
        <ul class="text item">
          <router-link v-for="(tips,index) of tipsData.data" :key="tips.id" :to="{name:'NoticeItem',query:{id: tips.id,type: 'tips'}}" tag="li">
            <i v-show="tips.is_top == 1" class="el-icon-star-on"></i>  <span v-text="tips.title"></span>
          </router-link>
	  		  <li class="not-more" v-show="tipsLoaded">已经是最后一页了</li>
        </ul>
        <div class="btn-box">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="changeTipsList"
            :current-page="tipsData.current_page"
            :total="tipsData.total">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="答疑解惑" name="question">
        <ul class="text item">
          <router-link  v-for="(question,index) of questionData.data"  :key="question.id" :to="{name:'NoticeItem',query:{id: question.id,type: 'question'}}" tag="li">
            <i v-show="question.is_top == 1" class="el-icon-star-on"></i>  <span v-text="question.title"></span>
          </router-link>
        </ul>
        <div class="btn-box">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="changeQuestionList"
            :current-page="questionData.current_page"
            :total="questionData.total">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Notice',
  data () {
    return {
      activeNotice: 'notice',
      noticeData: {},
      tipsData: {},
      questionData: {},
      noticeLoaded: false,
      tipsLoaded: false
    }
  },
  created() {
    this.getNoticeList(1);
  },
  methods: {
    changeNoticeList(val) {
      this.getNoticeList(val);
    },
    changeTipsList(val) {
      this.getTipsList(val);
    },
    changeQuestionList(val) {
      this.getQuestionList(val);
    },
    handleClick(tab, event) {
      let _this = this;
      let _index = tab.index;
      console.log(_index)
      switch (_index) {
        case '0':
          _this.getNoticeList(1);
        case '1':
          _this.getTipsList(1);
          break;
        case '2':
          _this.getQuestionList(1);
          break;
        default:
          return;
      }
    },
    getNoticeList(page) {
      var _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/notice/list?page=' + page
      }).then((res) => {
        let data = res.data.data;
        _this.noticeData = data;
      })
    },
    getTipsList(page) {
      var _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/card/list?page=' + page
      }).then((res) => {
        let data = res.data.data;
        _this.tipsData = data;
      })
    },
    getQuestionList(page) {
      var _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/wx/question/list?page=' + page
      }).then((res) => {
        let data = res.data.data;
        _this.questionData = data;
      })
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  #notice
    width 940px
    margin 0 auto 20px auto
    ul
      min-height 300px
      li
        height: 30px
        line-height: 30px
        cursor: pointer
        i
          color: red
      li:hover
        color: red
      .not-more
        height: 40px
        line-height: 40px
        text-align
        color: #999
</style>



// WEBPACK FOOTER //
// src/components/notice/notice.vue